
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import $ from 'jquery';
import { handleError, initClient } from "../../../../api";
import { DutyClient, OptionItem } from "../../../backend/backendapi";
import CenterOnParent from "../../../util/CenterOnParent";
import Spinner from "../../../util/Spinner";

@Component({
  name: 'DutySettingsModal',
  components: {
    CenterOnParent,
    Spinner,
  }
})
export default class DutySettingsModal extends Vue {
  readonly templates: OptionItem[] = [];
  readonly selected: OptionItem[] = [];
  readonly api = initClient(DutyClient);
  importing: boolean = false;

  async mounted(): Promise<void> {
    await this.reloadTemplates();
  }

  async reloadTemplates(): Promise<void> {
    const templates = await this.api.getTemplates();
    this.templates.splice(0);
    this.templates.push(...templates);
  }

  open(): void {
    $(this.$refs.modal!).modal('show');
    this.selected.splice(0);
    this.importing = false;
  }

  dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  async importTemplates(): Promise<void> {
    this.importing = true;
    try {
      await this.api.importTemplates(this.selected);
      this.$toasted.info(this.$t('duty.imported').toString());
    } catch (err) {
      handleError(this.$toasted, this.$i18n, err);
    } finally {
      this.importing = false;
    }
    this.$emit('imported');
  }
}
